import RichTextInput from "ra-input-rich-text";
import * as React from "react";
import { TextInput, Edit, TabbedForm, FormTab, BooleanInput, ImageInput, ImageField, ReferenceArrayInput, SelectArrayInput, ReferenceInput, AutocompleteInput, ArrayInput, SimpleFormIterator, NumberInput, TranslatableInputs, useLocale, FormDataConsumer } from 'react-admin';
import { toolbarOptions } from "../../lib/editorOptions";
import { locales } from "../../lib/utils";
import { validateRequired } from "../../lib/validations";

const CourseTitle = ({ record }) => {
    const locale = useLocale();
    return <span>{record ? record.title[locale] : ''}</span>;
};

const CourseEdit = (props) => {
    const locale = useLocale();
    return (
        <Edit title={<CourseTitle />} {...props}>
            <TabbedForm redirect="edit">
                <FormTab label="Conteúdo">
                    <TranslatableInputs locales={locales}>
                        <TextInput source="title" validate={validateRequired} label="Título" />
                        <RichTextInput source="content" validate={validateRequired} toolbar={toolbarOptions} label="Conteúdo" />
                        <BooleanInput source="published" label="Publicado" />
                    </TranslatableInputs>
                    <ReferenceArrayInput source="categories_ids" reference="categories" label="Categorias" filter={{ parent_id: 'dropdown' }}>
                        <SelectArrayInput optionText={`name[${locale}]`} />
                    </ReferenceArrayInput>
                    <ReferenceArrayInput source="tags_ids" reference="tags">
                        <SelectArrayInput optionText={`name[${locale}]`} />
                    </ReferenceArrayInput>
                </FormTab>
                <FormTab label="Imagens">
                    <ImageInput source="image" label="Imagem de capa" accept="image/*">
                        <ImageField source="src" title="title" />
                    </ImageInput>
                    <ImageInput source="gallery" label="Galeria" accept="image/*" multiple>
                        <ImageField source="src" title="title" />
                    </ImageInput>
                </FormTab>
                <FormTab label="Percurso">
                    <ArrayInput source="pois_ids" label="Ponto de interesse">
                        <SimpleFormIterator>
                            <ReferenceInput reference="pois" label="Título">
                                <AutocompleteInput optionText={`title[${locale}]`} />
                            </ReferenceInput>
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>
                <FormTab label="Preço">
                    <BooleanInput source="price[free]" label="Gratuito" />
                    <FormDataConsumer>
                        {({ formData, ...rest }) => {
                            return ((!formData.price || !formData.price.free) && <NumberInput source="price[value]" {...rest} label="Preço" />)
                        }
                        }
                    </FormDataConsumer>
                    <TranslatableInputs locales={locales}>
                        <TextInput source={`price[info]`} label="Mais informações" />
                    </TranslatableInputs>
                </FormTab>
                <FormTab label="Informação percurso">
                    <BooleanInput source="info[signs]" label="Sinais" />
                    <NumberInput source="info[distance]" label="Distância" />
                    <TextInput type="time" source="info[time]" label="Duração" />
                    <TranslatableInputs locales={locales}>
                        <TextInput source="info[difficulty]" label="Dificulade" />
                    </TranslatableInputs>
                </FormTab>
            </TabbedForm>
        </Edit>
    )
};

export default CourseEdit;